/** How long a page lets the queue pick up a saved `ready` stage before it wakes
 * the stage itself. The server's claim guards the stage, so a wake that races a
 * delivery cannot run or pay for it twice. */
export const JOURNEY_STALL_MS = 60_000;

/** Reports true when the same saved checkpoint has stayed unchanged for
 * JOURNEY_STALL_MS, then starts the wait again. */
export function journeyStallWatch(now: () => number = Date.now): (checkpoint: string) => boolean {
  let seen = '', since = 0;
  return checkpoint => {
    const at = now();
    if (checkpoint !== seen) { seen = checkpoint; since = at; return false; }
    if (at - since < JOURNEY_STALL_MS) return false;
    since = at;
    return true;
  };
}
